import React from "react";
import WellDone from "../../../../assets/svgs/gameplay/WellDone";
import { getWidth } from "../../../../utils/relativeSizes";
import CommonAnimation from "./CommonAnimation";

const WellDoneAnimation = () => {

  return (
    <CommonAnimation>
      <WellDone width={getWidth(119)} height={getWidth(60)} />
    </CommonAnimation>
  );
};

export default WellDoneAnimation;
